module.exports = __webpack_public_path__ + "static/media/bancomer.e57062ef.png";